import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { MixedItem } from 'store/railsBuilder/reducer.types';

import { HOVER_EPISODE, HOVER_SEASON } from 'screens/Detail/languageConst';

function useSeriesMetadata(item: MixedItem) {
    const { t } = useTranslation();

    const seriesMetadata = useMemo(() => {
        const seriesTitle: string[] = [];

        if (item.seriesId) {
            if (item.season) {
                seriesTitle.push(`${t(HOVER_SEASON)}${item.season}`);
            }

            if (item.episode) {
                seriesTitle.push(`${t(HOVER_EPISODE)}${item.episode}`);
            }

            if (item.episodeTitle) {
                seriesTitle.push(item.episodeTitle);
            }
        }

        return seriesTitle.length ? seriesTitle.join(' ') : '';
    }, [item, t]);

    return seriesMetadata;
}

export default useSeriesMetadata;
